module.exports = __webpack_public_path__ + "static/shop-background-ff88749a38ffcaf7e7b7e21e2355c4b5.jpg";